import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import VotingList from '../components/VotingList';
import ProtectedRoute from '../components/ProtectedRoute';
import './VoteOtt.css';
import { voteStore } from '../utils/voteStore';
import { useVotingOptions } from '../context/VotingOptionsContext';

const submitAll = async (apiUrl, payload) => {
  const res = await fetch(apiUrl, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error('Submit failed');
  return res.json().catch(() => ({}));
};

const VoteOtt = () => {
  const navigate = useNavigate();
  const [ottSelected, setOttSelected] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { options, isLoading, error } = useVotingOptions();

  useEffect(() => {
    const saved = voteStore.getSelections('ott');
    if (Array.isArray(saved) && saved.length) setOttSelected(saved);
  }, []);

  const handleSubmit = useCallback(async () => {
    const canSubmit = (ottSelected || []).length === 4;
    if (!canSubmit || isSubmitting) return;
    const payload = voteStore.getAll();
    setIsSubmitting(true);
    try {
      // await submitAll('https://mca.hot-mob.com/api/voting/create', payload);
      await submitAll('https://mca.hot-mob.com/api/voting/create', payload);
      voteStore.clear();
      navigate('/results', { replace: true, state: { success: true } });
    } catch (e) {
      navigate('/results', { replace: true, state: { success: false, error: e?.message || 'Submit failed' } });
    } finally {
      setIsSubmitting(false);
    }
  }, [isSubmitting, navigate, ottSelected]);

  return (
    <ProtectedRoute>
      <div className="voting-page-container">
        <div className="container">
          <VotingList
            title="請投選4個最熱門OTT平台"
            subtitle="（投票前，可點擊‘前往’瀏覽其OTT平台以了解更多）"
            nextUrl={null}
            items={options.ott}
            maxSelections={4}
            storageKey="ott"
            showBackButton={true}
            backUrl="/voting/fb"
            handleUpdate={setOttSelected}
            forceLoading={isLoading}
            forceError={error}
          />

          <div className="submit-button-container">
            <button
              className={`btn btn-primary btn-large${ottSelected.length < 4 || isSubmitting ? ' disabled-button' : ''}${
                isSubmitting ? ' submitting-button' : ''
              }`}
              id="submit-button"
              onClick={handleSubmit}
              disabled={ottSelected.length < 4 || isSubmitting}
              aria-disabled={ottSelected.length < 4 || isSubmitting}
              aria-busy={isSubmitting}
            >
              {isSubmitting ? '提交中...' : '提交'}
            </button>
          </div>
        </div>
      </div>
    </ProtectedRoute>
  );
};

export default VoteOtt;
